(() => {
  const root = document.documentElement;
  const desktop = window.matchMedia('(min-width: 1025px)');
  const collapseAt = 72;
  const restoreAt = 2;

  let collapsed = root.classList.contains('pm-header-scrolled');
  let frame = 0;

  const closeMegaMenus = () => {
    document.querySelectorAll('.header__nav details[open]').forEach((details) => {
      details.open = false;
      details.classList.remove('is-open');

      const summary = details.querySelector(':scope > summary');
      summary?.setAttribute('aria-expanded', 'false');
    });
  };

  const closeLocalization = () => {
    document
      .querySelectorAll('.header__localization .localization-panel.is-open')
      .forEach((panel) => panel.classList.remove('is-open'));

    document
      .querySelectorAll('.header__localization .js-language-switcher-btn[aria-expanded="true"]')
      .forEach((button) => button.setAttribute('aria-expanded', 'false'));
  };

  const closeDesktopPanels = () => {
    closeMegaMenus();
    closeLocalization();
  };

  const update = () => {
    frame = 0;

    if (!desktop.matches) {
      collapsed = false;
      root.classList.remove('pm-header-scrolled');
      return;
    }

    const scrollTop = Math.max(window.scrollY, document.documentElement.scrollTop);
    let next = collapsed;

    if (!collapsed && scrollTop > collapseAt) {
      next = true;
    } else if (collapsed && scrollTop <= restoreAt) {
      next = false;
    }

    if (next === collapsed) return;

    collapsed = next;
    root.classList.toggle('pm-header-scrolled', collapsed);

    if (collapsed) closeDesktopPanels();
  };

  const schedule = () => {
    if (frame) return;
    frame = window.requestAnimationFrame(update);
  };

  update();
  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('pageshow', update);
  desktop.addEventListener('change', update);
})();
